export const PNR_NUMBER = 'Please enter the PNR number';
export const CHECK_STATUS = 'CHECK PNR STATUS';
export const PNR_URL = 'https://www.makemytrip.com/railways/pnrsearch/?pnr=';
export const MMT_TRAINS_URL = 'https://www.makemytrip.com/railways/';
export const MOBILE_PNR_URL = 'https://www.makemytrip.com/railways/PNR/';
export const CHECK_PNR_STATUS = 'PNR Status';
export const IRCTC_AUTHORIZED_TICKETING = 'IRCTC Authorized e-ticketing';
export const ENTER_10Digit_PNR = 'Enter 10 Digit PNR';
export const PNR = 'PNR';

export const PNR_PAGE_CONTENT = [
  {
    description: `<h2 class="contentHeading">What is PNR Status?</h2>
    <div class="contentDescription"><p>PNR status refers to the status of a booked train ticket checked via PNR or Passenger Name Record. When going for a <strong>train PNR status check</strong>, you will get either of the following statuses, thus helping decide whether you can commence the journey with the booked ticket or not.</p></div><br/>
    <ul class="list appendBottom10">
    <li><strong>CNF or Confirmed status:</strong>
    This status shows ticket confirmation status, displaying the allotted coach and berth for the passenger/s.</li>
    <li><strong>RAC or Reservation Against Cancellation status:</strong>
    If the <strong>Indian Railway PNR status</strong> shows RAC, it reflects the likelihood of the passenger getting a ticket confirmation if someone cancels. The number reflecting with RAC status refers to the RAC queue. A passenger can still travel if the <strong>PNR status check for railway ticket</strong> shows RAC.</li>
    <li><strong>WL or Waiting List/Waitlist:</strong>
    If the <strong>PNR status check online</strong> reflects WL as the status, it refers to the Waiting List status of the ticket.</li>
    </ul>
    <div class="contentDescription"><p>While these statuses reflect results for <strong>PNR status enquiry</strong> of booked tickets, a cancelled ticket also carries a CAN/MOD PNR status. The status is updated as Cancelled right after the cancellation of a booked ticket is complete.</p></div>
    `
  },
  {
    description: `<h2 class="contentHeading">How to Get Live PNR Status Updates</h2>
    <div class="contentDescription"><p>You can get an update of your <strong>PNR status live</strong> right from the time of ticket booking up to the train’s scheduled departure. In case the tickets are not available for your selected train and coach type, booking the ticket results in a Waitlisted <strong>PNR status 10 digit</strong> and updates further.</p></div><br/>
    <div class="contentDescription"><p>The <strong>railway PNR status check</strong> also reflects dynamic updates in real-time. For instance, if the waitlisted queue in the WL status reduces, the numeric changes are available subsequently. Similarly, if the train ticket moves from Waitlisted to RAC status, the update is dynamically reflected in the <strong>PNR status online.</strong> Once the RAC queue is over, the booked ticket gets a Confirmed PNR status.</p></div><br/>
    <div class="contentDescription"><p>Depending on the ticket cancellations by existing passengers, the <strong>IRCTC PNR status</strong> moves from WL to CNF dynamically and in real-time. The update occurs frequently and the timeframe follows the rate of booking cancellations from existing passengers. Some top factors that influence the change in the PNR status of your train ticket can be - </p></div><br/>
    <ul class="list appendBottom10">
      <li>An existing ticket with confirmed or RAC status that is cancelled affects the probability of your PNR status and its change thereto.</li>
      <li>Any ongoing festive season can influence your PNR status, whereby chances of confirmation are reduced due to low cancellations of existing confirmed tickets.</li>
      <li>Any upgrade or downgrade of allotted seats also affects the PNR status of passengers.</li>
      <li>In case the train is rescheduled or cancelled, your PNR status shall change too.</li>
      <li>Confirmation of a waitlisted ticket also changes the PNR status.</li>
    </ul>
    <div class="contentDescription"><p>In case the chart is prepared and there is no seat allotment, your PNR status shall change from Waiting List to Cancelled/Modified.</p></div>
    `,
    key: 'livePNRStatus'
  },
  {
    description: `<h2 class="contentHeading">Checking PNR Status by Name or Other Details</h2>
        <div class="contentDescription"><p>It is not possible to check <strong>PNR status with name</strong> or any other personal or ticket details. You can check your PNR status only with the provided 10-digit PNR number. IRCTC provides the online facility of checking PNR status through its official website/app and authorised partnering platforms like MakeMyTrip.</p></div><br/>
        <div class="contentDescription"><p>The search process for passenger itineraries provided via <strong>PNR status check</strong> is easy and simple. Its accessibility can be a risk and raise privacy concerns if allowed through name or other personal/ticket details. The <strong>PNR status railway</strong> service is thus accessible only through the unique 10-digit PNR number sent to the passenger’s registered mobile number and email ID.</p></div>
        `,
    key: 'PNRCheck'
  },
  {
    description: `<h2 class="contentHeading">What is a PNR Number?</h2>
      <div class="contentDescription"><p>A PNR or Passenger Name Record number is a unique 10-digit alphanumeric code allotted to each booked ticket. If you book tickets for more than one passenger at a go, all the tickets will have the same PNR number. Following are the important details that a PNR number carries.</p></div><br/>
      <ul class="list appendBottom10">
      <li>Passenger’s name, age, berth preference and gender</li>
      <li>Travel details like train number, coach number, berth number, class of travel, and station of departure</li>
      <li>Itinerary details like booking status, current status, time of journey, and time of departure/arrival</li>
      <li>Payment details like transaction ID, payment mode and fare</li>
      </ul>
      <div class="contentDescription"><p>Each ticket booking comes with a unique 10-digit PNR allotment sent to the registered mobile number and email ID. A PNR number carries a 9-month validity or until journey completion, whichever is earlier. Once the journey is completed, the PNR number becomes inactive.</p></div><br/>
      <div class="contentDescription"><p>PNR number is important in ensuring easy PNR status check with live updates of changes in ticket status and its queue. The PNR number is printed on each train ticket’s top left corner.</p></div>
      `,
    key: 'PNRNumber'
  },
  {
    description: `<h2 class="contentHeading">How to Check PNR Status through IRCTC</h2>
    <div class="contentDescription appendBottom10"><p>When you receive your PNR number you also receive a <strong>PNR status</strong>. There are many <strong>PNR status</strong> provided by the Indian Railways. Each defines the status of your <strong>train ticket bookings</strong>. Here's what some of the abbreviations stands for:</p></div>
    <ol class="list">
    <li>Visit the official IRCTC website or app.</li>
    <li>Go to the ‘PNR Status’ or ‘PNR Status Check’ option available on the homepage.</li>
    <li>On the new page, enter your 10-digit PNR number in the designated space and click on ‘Check Status’.</li>
    <li>It will then redirect you to your PNR number details, including your ticket confirmation with coach and berth allotment details if allotted already.</li>
    </ol>`,
    key: `PNRStatusTypes`
  },
  {
    description: `<h2 class="contentHeading">How to Check PNR Status through MakeMyTrip?</h2>
        <div class="contentDescription"><p>The facility to check Indian Railway PNR status is also available with MakeMyTrip, IRCTC’s authorised booking partner. Complete the steps below to check your PNR status on the platform.</p></div><br/>
        <ol class="list appendBottom10">
        <li>Visit MakeMyTrip’s official website or app.</li>
        <li>On the homepage, go to ‘Trains’ and click on the ‘PNR Status/PNR Status Check’ service.</li>
        <li>On the service page that opens, enter the 10-digit PNR number.</li>
        <li>You can then click on ‘Check’ to find the status of your PNR number displayed on the screen instantly as WL, RAC or CNF along with all other pertinent itinerary details.</li>
        </ol>
        <div class="contentDescription"><p>On the platform, you can also find <strong>PNR status prediction</strong>, informing you about your chances of ticket status clearance from waitlisted to RAC or confirmed. With MakeMyTrip’s PNR status service available online, you can go for <strong>PNR status live check on mobile</strong> or any other internet-connected device with ease.</p></div>
        `,
    key: 'PNRValidity'
  },
  {
    description: `<h2 class="contentHeading">Other Ways to Check Your PNR Status</h2>
        <div class="contentDescription"><p>You can explore various other ways to check your PNR status as well. Here’s a list to check.</p></div>
        <br/>
        <ol>
          <strong><li>PNR status check via SMS</li></strong>
          <p>You can send your 10-digit PNR number via SMS on 139 or 5676747 and receive PNR status with other details instantly via a response SMS.</p><br/>
          <strong><li>PNR status check via Call</li></strong>
          <p>The service to check PNR status is also available via call. You can connect with the Indian Railways IVR by dialling 139 and following the options to check your PNR status right away.</p><br/>
          <strong><li>At the Railway Enquiry Counter</li></strong>
          <p>An in-person check at the Railway Enquiry counter also facilitates a necessary update regarding your booked ticket’s PNR status.</p><br/>
          <strong><li>Via final reservation chart</li></strong>
          <p>For a last-minute confirmation of your booked train ticket’s PNR status, you can also check it through the final reservation chart displayed on the railway station platform.</p><br/>
          <p>With the availability of an online facility for checking PNR status, you can check your ticket confirmation status right away. Thus, going for the inconvenient in-person enquiries and checks is not suggested. Simply visit IRCTC or MakeMyTrip’s official website/app to check.</p>
        </ol>
        `,
    key: 'ConfirmedPNR'
  },
  {
    description: `<h2 class="contentHeading">PNR Abbreviations Fact Sheet</h2>
        <div class="contentDescription"><p>Here’s a quick glimpse at the PNR abbreviations you must know to stay well-informed about your train ticket status.</p></div>
        <br/>
        <ul class="highphenList appendBottom10">
          <li>PNR: Passenger Name Record</li>
          <li>CNF: Confirm</li>
          <li>WL: Waiting List</li>
          <li>RAC: Reservation Against Cancellation</li>
          <li>CAN/MOD: Cancellation/Modification</li>
        </ul>
        <div class="contentDescription"><p>The WL status can be of different types depending on the queue your ticket is in. They can be - </p></div>
        <br/>
        <ol class="list appendBottom10 appendLeft30">
          <li>RLWL or Remote Location Waiting List</li>
          <li>GNWL or General Waiting List</li>
          <li>CKWL or Tatkal Quota Waiting List (CK is the Tatkal Quota code)</li>
          <li>PQWL or Pooled Quota Waiting List</li>
          <li>RSWL or Roadside Station Waiting List</li>
          <li>RQWL or Request Waiting List</li>
        </ol>
        `,
    key: 'PNRFactSheet'
  },
  {
    description: `<h2 class="contentHeading">PNR Status Enquiry Quick Facts</h2>
        <table border="1" class="pnrTable"> <tbody>
          <tr> <td>What is PNR in e-ticket?</td><td>Passenger Name Record</td> </tr>
          <tr> <td>Length of PNR no.</td><td>It is a 10-digit unique code.</td> </tr>
          <tr> <td>Meaning of first 3 digits of your PNR</td><td>In the PNR number, the first 3 digits are called PRS. They give information about the system used by passengers to book train tickets.</td> </tr>
          <tr> <td>Meaning of last 7 digits of your PNR</td><td>The last seven digits are randomly generated by the system.</td> </tr>
          <tr> <td>Validity period of a PNR number</td><td>A PNR is applicable for the maximum of 9 months. After that period, it becomes invalid. Same PNR can be generated after a year.</td> </tr>
        </tbody> </table>`,
    key: 'PNRTable'
  }
];

export const downloadAppData = {
  search: 'Search',
  placeholder: 'Enter Mobile Number',
  heading: 'Download App Now',
  subHeading: `Get the MakeMyTrip mobile app and save more!`,
  inputDesc: `Use code <span class='latoBlack blackText'>MMTALWAYS</span> and get upto ₹ <span class='latoBlack blackText'>750</span> off on your first domestic flight booking.`,
  countryCode: ' +91',
  info: 'MORE WAYS TO GET THE APP',
  extraInfo: 'Scan QR Code',
  sent: 'Sent',
  getLink: 'Get app link',
  numberIncomplete: `Incomplete phone number, please check`
};

export const ticketStatusTilesData = [
  {
    iconName: 'railSeoSprite railIcon2',
    text: 'Book Train Ticket',
    url: 'https://www.makemytrip.com/railways/',
    key: 'Trains'
  },
  {
    iconName: 'railSeoSprite liveTrainStatus',
    text: 'Live Train Status',
    url: 'https://www.makemytrip.com/railways/liveStatus/',
    key: 'LTS'
  }
];

export const productFeaturesCardData = {
  label: 'Easily check PNR Status & book IRCTC train tickets with MakeMyTrip',
  listItems: [
    {
      iconName: 'railSeoSprite bluePnrStatus',
      label: 'PNR Status',
      subLabel:
        'Check your PNR status and with our Trip Guarantee feature, get a confirm IRCTC ticket of 3X refund incase ticket is not confirmed. You can also opt for real time PNR status update on WhatsApp.'
    },
    {
      iconName: 'railSeoSprite blueTripGuarantee',
      label: 'Trip Guarantee',
      subLabel:
        'Rest assured about your upcoming travel plans, even when the PNR status is waitlisted. With Trip Guarantee, get a confirmed ticket or receive a 3X refund.'
    },
    {
      iconName: 'railSeoSprite blueFreeCancellation',
      label: 'Free Cancellation',
      subLabel:
        'Keep your travel plans flexible. When you book with free cancellation, you get a full and instant refund for your ticket cost, whether the PNR status is confirmed or waitlisted.'
    },
    {
      iconName: 'railSeoSprite blueLiveTrainStatus',
      label: 'Live Train Status',
      subLabel:
        'Apart from the PNR status, you can also check the live train status on the MakeMyTrip app or website. Stay updated about route, running time, schedule, delays, and more along the way.'
    },
    {
      iconName: 'railSeoSprite blueHighestBookingSuccess',
      label: 'Highest Booking Success',
      subLabel:
        'MakeMyTrip offers seamless and instant train booking. On the app or website, you can get real-time info on the PNR status, live train status, and other important details.'
    },
    {
      iconName: 'railSeoSprite blueBookNowPayLater',
      label: 'Buy Now, Pay Later',
      subLabel: 'Make a booking by paying only Rs.0 now and pay the amount later! Offering starts at 0% interest.'
    },
    {
      iconName: 'railSeoSprite blueGreatOffers',
      label: 'Great offers & discounts',
      subLabel:
        'Book your ticket through MakeMyTrip App or website and pay 0 convenience fee on your first train ticket.'
    },
    {
      iconName: 'railSeoSprite blueAlternateRoute',
      label: 'Alternate Route Tickets',
      subLabel:
        'With our alternate route feature, increase your chances of getting confirm IRCTC train tickets and easily check and get instant updates of your PNR Status.'
    }
  ]
};

export const PNR_META_DATA = {
  template_name: `pnr-search`,
  title: `PNR Status | IRCTC PNR Status Check Online`,
  description: `Check PNR Status Online With Make My Trip and get PNR prediction of your waitlist ticket confirmation. Once the waitlist movement happens, the status of PNR changes. At Makemytrip.com, you can set alerts for Waitlist movement as well as check the PNR status online.`,
  keywords: ` PNR Status, PNR Status live, PNR Status online, Check PNR Status, Check IRCTC PNR Status, IRCTC PNR, Indian Railway PNR, PNR Prediction`,
  h1Title: `PNR Status`
};

export const PNR_FAQ = {
  list: [
    {
      question: `Q. How to Check PNR Status?`,
      answer: `<b>A:</b> You can check PNR Status online via makemytrip.com. Follow the steps mentioned below:<br/>Step 1: Go to Makemytrip website or download the Makemytrip app.<br/>Step 2: Click on 'Check PNR Status' button.<br/>Step 3: Enter your 10 digit PNR number and search. You will get your booked train ticket current status along with passengers details.`
    },
    {
      question: 'Q. What does a PNR number store?',
      answer: `<b>A:</b> A PNR no. has the following information: Details of the passenger, which include name, age and gender. Details of the train, which include train number, coach and seat numbers, class of travel and departure station. Details of the ticket, which include the mode of payment, transaction ID and fare.`
    },
    {
      question: 'Q. How is a PNR number issued for a train?',
      answer: `<b>A:</b> The PNR number contains two parts and the first three digits specify the area from where the ticket is booked. The starting digit of the PNR number indicates from where the train would start. As any Indian Railways train ticket is booked from a PRS (Passenger Reservation System), the two succeeding digits after the first number will denote the particular PRS. When the PNR number on the train ticket begins from 1, it will originate from SCR zone from Secunderabad PRS. When the PNR no. begins from 2 or 3, it will be issued from NR, NCR, NWR, or NER from New Delhi PRS. With starting digits 4 or 5 on the PNR number, the point of origin can be SWR, SCR, or SR from Chennai PRS. When the PNR number starts from 6 or 7, it will originate from station codes, NFR, ECR, ER, ECoR, SER, or SECR, from Kolkata PRS. With 8 or 9 as the beginning digit, the PNR issued will be from CR, WCR, or WR, from Mumbai PRS. The last 7 digits of an Indian Railways PNR number are produced at random to give it a unique identity.`
    },
    {
      question: 'Q. How to find the PNR number on a train ticket?',
      answer: `<b>A:</b> On an Indian railways train ticket, you can find the PNR number on the top left hand corner. When you have booked an e-ticket from IRCTC website, or from an online travel website, the number would be present on the top section. To check your PNR status, visit <a href="#" onclick="window.scrollTo(0, 0); return false;">PNR</a> and type in the PNR no. and details, and instantly get the updated result.`
    },
    {
      question: 'Q. How to check PNR status on a phone?',
      answer: `<b>A:</b> Check PNR Status by sending SMS on:<br>Type 'PNR (10-digit PNR Number)' and send it to 139.`
    },
    {
      question: 'Q. Is PNR number allotted for unreserved and reserved tickets?',
      answer: `<b>A:</b> PNR number is only allotted for reserved tickets.`
    },
    {
      question: 'Q. Where is the PNR number printed on a train ticket?',
      answer: `<b>A:</b> If the train ticket is bought at a railway station, you can find your PNR number on the top left of your ticket. In case the ticket is bought online, the PNR number would be separately displayed on the top of the train ticket.`
    },
    {
      question: 'Q. Can we travel with only the PNR number?',
      answer: `<b>A:</b> Yes, passengers can travel without tickets, if the PNR status is confirmed. If you don’t have the ticket, approach the TC and give the details of your ticket along with a valid ID proof for verification.`
    },
    {
      question: 'Q. What do CNF, RAC, and WL mean in PNR status?',
      answer:
        '<b>A:</b> When you check your <strong>Indian Railway PNR status</strong>, either of the three statuses are displayed, i.e., CNF, RAC and WL. CNF refers to the confirmation of booked tickets and seat allotment in your selected coach type. When the PNR status shows RAC, it refers to Reservation Against Cancellation and allows travel on the booked train. However, it does not guarantee separate berth allotment and the passenger often has to share a berth with another co-passenger if the ticket remains under RAC status. <br/><br/>WL for PNR status indicates Waiting List, which means that all berth tickets are booked. The number associated with WL status indicates the passenger’s queue in the Waiting List before the status moves to RAC and then CNF seat allotment.'
    },
    {
      question: 'Q. How often is PNR status updated by Indian Railways?',
      answer:
        '<b>A:</b> The Indian Railways updates the Passenger Name Record or PNR status frequently, and many times the changes reflect in real-time as <strong>PNR status live</strong>. It helps confirm the itinerary of the passengers as and when they need it. Easy PNR enquiry can be done in real-time via the IRCTC platform. MakeMyTrip, the official booking partner of IRCTC also provides updated PNR status in real-time.'
    },
    {
      question: 'Q. What does it mean if my PNR status shows RLWL or GNWL?',
      answer:
        '<b>A:</b> The Waiting List status on your <strong>PNR status enquiry</strong> can reflect different types of waiting lists with varying degrees of confirmation chances. RLWL and GNWL are two such Waiting List status types. RLWL means Remote Location Waiting List while GNWL refers to General Waiting List. RLWL reflects the waiting list for a small berth quota for train boarding at intermediate stations on the route. GNWL on the other hand is a common waiting list type with higher chances of confirmation than RLWL. '
    },
    {
      question: 'Q. Why should I check my PNR status before travelling?',
      answer:
        '<b>A:</b> You should go for your <strong>train PNR status check</strong> before travelling because it helps to know whether your ticket is confirmed with an allotted berth, on the waiting list or on RAC. You can thus plan your journey accordingly and avoid facing any inconvenient experiences. <br/><br/>A confirmed ticket or ticket with RAC status enables train boarding while waitlisted tickets do not allow boarding. Checking your PNR status from time to time also helps gauge the chances of confirmation so that you can make necessary arrangements alternatively if needed. Checking the status of your PNR also allows a quick look at berth and coach number, if confirmed. When checking your PNR status, you can also get to know about train schedule changes, if any.'
    },
    {
      question: 'Q. How can I check PNR status through SMS or the IRCTC website?',
      answer:
        '<b>A:</b> You can check your PNR status easily through SMS or the IRCTC website. When going for <strong>PNR status live check on mobile</strong> through SMS, simply type your 10-digit PNR number as a message and send it to 139 or 5676747. You will get all the status details related to your PNR, including coach and berth numbers, if confirmed. <br/><br/>The IRCTC website also provides an easy facility to check PNR status. On the website, click on the ‘PNR Status’ option and enter your PNR on the next page that opens. All the PNR and ticket details will be displayed on the page for you.'
    },
    {
      question: 'Q. Can I track my train’s platform and running status with my PNR?',
      answer:
        '<b>A:</b> No, the PNR status feature does not provide details related to your <a href="https://www.makemytrip.com/railways/liveStatus/">train’s running status</a> or the platform it will arrive on. With your PNR status check, you can only check if the ticket is confirmed, the seat and coach allotted, the type of waiting list, and other pertinent details related to the ticket. '
    },
    {
      question: 'Q. Can I cancel a train ticket booked through MakeMyTrip? If yes, will the PNR be updated?',
      answer:
        '<b>A:</b> Yes, the feature to cancel a ticket booked through MakeMyTrip is available on the online platform. Once you cancel your train ticket booked with MakeMyTrip, the booked berth is released and a fare refund is initiated. Once the ticket is cancelled, your <strong>PNR status check online</strong> shall reflect CAN/MOD status, meaning Cancelled/Modified.'
    },
    {
      question:
        'Q. What are my options if my ticket is still waitlisted after the PNR Status Check on the day of travel?',
      answer:
        '<b>A:</b> If your train ticket remains waitlisted after the <strong>PNR Status check</strong> on the day of travel, you can either cancel your ticket before chart preparation or wait for confirmation. Ticket cancellation is allowed until 4 hours before the departure schedule. In case you are waiting for confirmation of your ticket booked online until the last minute and the chart is prepared while the ticket remains waitlisted, it will be automatically cancelled. On automatic cancellation of the waitlisted ticket, the ticket fare is fully refunded. <br/><br/>For waitlisted tickets booked at the counter, one can either surrender the ticket for a refund or board an alternative unreserved coach of the train. In the case of waitlisted Tatkal tickets, a full refund is provided.'
    },
    {
      question: 'Q. What happens if my RAC ticket is not confirmed after the PNR Status Check Online?',
      answer:
        '<b>A:</b> If your RAC ticket is not confirmed after the <strong>PNR status check online</strong>, you can still board your train and get on the RAC allotted coach and berth. Reservation Against Cancellation tickets, however, do not provide complete berth allotment and often a co-passenger travels along on the same berth. In that case, you can either board your train and travel with an RAC ticket or cancel your ticket 4 hours before the departure schedule.'
    },
    {
      question: 'Q. Can I check my PNR status without an internet connection?',
      answer:
        '<b>A:</b> Yes, if you do not have an internet connection, you can choose PNR status <strong>live check on mobile</strong> either through SMS or via call. When checking the PNR status through SMS, send your 10-digit PNR number to either 139 or 5676747. Alternatively, you can call 139 and follow the IVR options to check the PNR status.'
    }
  ],
  title: 'Train PNR Status FAQS'
};

export const PNR_APP_DOWNLOAD_SECTION_CONSTANTS = {
  heading: 'Download App Now',
  subHeading: 'Get the MakeMyTrip app and save more!',
  appStoreData: [
    {
      os: 'ios',
      heading: 'App store',
      rating: 4.7,
      reviewCountText: '1.4M reviews'
    },
    {
      os: 'android',
      heading: 'Google Play',
      rating: 4.6,
      reviewCountText: '1.9M reviews'
    }
  ]
};
